/* eslint-disable no-unused-vars */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import H1 from '../../components/h1';
import P from '../../components/p';
import Spacer from '../../components/spacer';
import Button from '../../components/button';
import songkick from '../../images/songkick.png';
import AppState from '../../store/appstate';
import { addArtistAccount, updateArtistAccountMeta } from '../../api/mutations';
import ApiErrorMessage from '../../components/apiErrorMessage';
import { getMyAccounts, getThemeUnAuth } from '../../api/queries';

function AddAccountFinal() {
  const { t } = useTranslation('onboarding');
  const history = useHistory();
  const accountData = AppState.useState((s) => s.addAccount);
  const [apiError, setApiError] = useState('');
  const [pending, setPending] = useState(false);
  const myAccounts = getMyAccounts();
  const theme = getThemeUnAuth();

  const addMutation = addArtistAccount();
  const accountMetaMutation = updateArtistAccountMeta();

  const updateAccountMeta = async (aac) => {
    // update account meta
    const data = {
      account_id: aac,
      facebook_obj: accountData?.facebook,
      spotify_obj: accountData?.spotify,
      songkick_obj: accountData?.songkick,
      twitter_obj: accountData?.twitter,
      bandsintown_obj: accountData?.bandsintown,
      instagram_obj: accountData?.instagram,
    };

    accountMetaMutation.reset();

    accountMetaMutation.mutate(data, {
      onSuccess: () => {
        setTimeout(() => {
          myAccounts.refetch();
          setTimeout(() => {
            history.push('/');
            setPending(false);
            AppState.update((s) => {
              s.addAccount = {
                name: null,
                live: null,
                streaming: null,
                spotify: null,
                facebook: null,
                songkick: null,
                bandsintown: null,
                instagram: null,
              };
            });
          }, 2000);
        }, 1000);
      },
      onError: (error) => {
        setApiError(error.message);
        setPending(false);
      },

    });
  };

  const addAccount = async () => {
    setPending(true);

    // add artist account to rights app
    const data = {
      cataloguecode: '',
      accountname: accountData.accountName,
      facebookpageurl: accountData.facebook,
      spotifyid: accountData.spotify ? JSON.parse(accountData.spotify).id : null,
      releasedtoserviceorstore: accountData.streaming === 'true',
      performedlastsixmonths: accountData.live === 'true',
      twitterprofileurl: accountData.twitter ? `https://twitter.com/${JSON.parse(accountData.twitter).data.username}` : null,
      soundcloudpageurl: null,
    };

    addMutation.reset();

    addMutation.mutate(data, {
      onSuccess: (result) => {
        const aac = result.model.artistaccountcode;

        updateAccountMeta(aac);
      },
      onError: (error) => {
        setApiError(error.message);
        setPending(false);
      },

    });
  };

  return (
    <div className="container mx-auto">
      <div className="flex flex-col justify-center items-center text-white p-4 text-center min-h-screen-minus-footer">

        <H1>
          {t('onboarding:welcome-to')}
          {' '}
          {theme?.data?.display_name}
        </H1>
        <Spacer />
        <P>{t('onboarding:completed-account-setup')}</P>

        <Spacer />
        <Button disabled={pending} pending={pending} onClick={() => { addAccount(); }}>{t('onboarding:go-to-dashboard')}</Button>
        <ApiErrorMessage apiError={apiError} />

      </div>
    </div>
  );
}

export default AddAccountFinal;
